import React, { useRef, useCallback, useEffect } from "react";
import { Message, Button, Input, Modal, Icon, Form } from "semantic-ui-react";
import "./style.less";
import cityIcon from "../../../icons/city.png";
import { useInput } from "../../../common/hooks";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  searchBounds,
  setDrawingOpts,
  publishCity,
  fetchAvailableCities,
  setErrorToastMessage,
  cancelGeofenceCreation,
  setCityName
} from "../../../redux/geofence/actions";
import FenceCoordsList from "../CityView/CreateGeofence/FenceCoordsList";
import { Link, useHistory } from "react-router-dom";

function CreateCity() {
  const dispatch = useDispatch();
  const history = useHistory();
  const availableCities = useSelector(
    ({ geofence }) => geofence.availableCities,
    shallowEqual
  );
  const currentCityName = useSelector(
    ({ geofence }) => geofence.currentCityName
  );
  useEffect(() => {
    if (availableCities === null) {
      dispatch(fetchAvailableCities());
    }
  }, [availableCities, dispatch]);
  const newCityName = useSelector(({ geofence }) => geofence.newCityName);
  const drawingOpts = useSelector(
    ({ geofence }) => geofence.drawingOpts,
    shallowEqual
  );
  const toPublishFence = useSelector(
    ({ geofence }) => geofence.toPublishFence,
    shallowEqual
  );

  const numGeofences = useSelector(
    ({ geofence }) => geofence.geofences.length,
    shallowEqual
  );

  const numGeofencesRef = useRef(numGeofences);
  useEffect(() => {
    if (numGeofencesRef.current + 1 === numGeofences) {
      numGeofencesRef.current = numGeofences;
      history.push(`/city/${newCityName}/geofences/add/success`);
    }
    numGeofencesRef.current = numGeofences;
  }, [numGeofences, history, newCityName]);

  const [cityNameInputVal, setCityNameInputVal] = useInput("");
  const searchButtonHandler = () => {
    if (
      availableCities &&
      availableCities
        .map(e => e.toLowerCase())
        .indexOf(cityNameInputVal.toLowerCase()) === -1
    ) {
      dispatch(searchBounds(cityNameInputVal));
    } else {
      dispatch(
        setErrorToastMessage(
          "City with this name already there. Edit it instead."
        )
      );
    }
  };
  const publishCityButtonHandler = useCallback(() => {
    dispatch(publishCity());
  }, [dispatch]);

  const cancelButtonHandler = useCallback(() => {
    dispatch(cancelGeofenceCreation());
    dispatch(setCityName(""));
    history.push(`/`);
  }, [dispatch, history]);

  const startDrawMode = () =>
    dispatch(
      setDrawingOpts({
        drawingMode: "polygon",
        fenceCategory: "SERVICEABLE_AREA",
        editable: true
      })
    );

  return (
    <div className="CreateCity">
      <Modal open={newCityName === ""} size="tiny">
        <Modal.Content className="center-text">
          <img src={cityIcon} alt="Create City" />
          <br />
          <br />
          <p>Search city You want to create</p>
          {/* For giving search on pressing enter button hack*/}
          <Form onSubmit={searchButtonHandler}>
            <Input
              icon="search"
              placeholder="Enter name"
              value={cityNameInputVal}
              onChange={setCityNameInputVal}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Link
            to={currentCityName ? `/city/${currentCityName}/geofences/` : "/"}
          >
            <Button color="red" inverted>
              Cancel
            </Button>
          </Link>
          <Button onClick={searchButtonHandler} color="green" inverted>
            Search
          </Button>
        </Modal.Actions>
      </Modal>
      <h2>
        Create <br /> New city
      </h2>
      <label>City Name</label>
      <Input fluid inverted placeholder="City Name" value={newCityName} />
      <br />
      <label>Category</label>
      <Input fluid inverted value="City bounds" />
      <br />
      <br />
      {!drawingOpts && !toPublishFence ? (
        <Button onClick={startDrawMode} fluid primary type="submit">
          Start Drawing
        </Button>
      ) : null}
      <div className={!drawingOpts ? "drawingModeOff" : ""}>
        <Message icon>
          <Icon name="info circle" />
          <Message.Content>
            Click on the map to start plotting points of the polygon. Last point
            and the starting point should be same. Click on starting point to
            complete polygon.
          </Message.Content>
        </Message>
      </div>
      <FenceCoordsList />
      <Button
        fluid
        primary
        inverted
        type="submit"
        className="cancelButton"
        onClick={cancelButtonHandler}
      >
        Cancel
      </Button>

      <Button
        disabled={!toPublishFence}
        fluid
        primary
        type="submit"
        className="publishButton"
        onClick={publishCityButtonHandler}
      >
        Publish Polygon
      </Button>
    </div>
  );
}

CreateCity.defaultProps = {};

CreateCity.propTypes = {};

export default CreateCity;
